import { render, staticRenderFns } from "./doctForm.vue?vue&type=template&id=e729653c&scoped=true&"
import script from "./doctForm.vue?vue&type=script&lang=js&"
export * from "./doctForm.vue?vue&type=script&lang=js&"
import style0 from "./doctForm.vue?vue&type=style&index=0&id=e729653c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e729653c",
  null
  
)

export default component.exports